import get from 'lodash/get';

import struct from 'Redux/analytics/structEvent';

/**
 * The GTM basket tags, transcribed. Both do the same thing in opposite directions:
 *
 *   cartBefore = {{Cart Before String}} ? {{Cart Before String}}.split(',') : []
 *   basketIds  = ({{Basket}} || []).map(item => item._id)
 *   diff       = <one side>.filter(x => <other side>.indexOf(x) < 0)
 *
 *   diff[0] ? trackStructEvent('basket', verb, diff[0], cartBeforeStr)
 *           : trackStructEvent('basket', verb)
 *
 * {{Cart Before String}} is payload.cartBefore; {{Basket}} is payload.data, the
 * cart AFTER.
 */

const cartBeforeStr = action => get(action, 'payload.cartBefore', '') || '';

const idsBefore = (action) => {
  const before = cartBeforeStr(action);
  return before ? before.split(',') : [];
};

const idsAfter = (action) => {
  const basket = get(action, 'payload.data');
  return Array.isArray(basket) ? basket.map(item => get(item, '_id')) : [];
};


/**
 * Returns the elements in `from` that are not in `against`.
 *
 * @param {Array} from
 * @param {Array} against
 * @returns {Array}
 */
const notIn = (from, against) => from.filter(x => against.indexOf(x) < 0);


const basketEvent = (action, verb, diff) => {
  if (!diff[0]) return struct({ category: 'basket', action: verb });
  return struct({
    category: 'basket',
    action: verb,
    label: diff[0],
    property: cartBeforeStr(action),
  });
};

export const basketAdd = action => basketEvent(
  action, 'add', notIn(idsAfter(action), idsBefore(action)),
);

export const basketRemove = action => basketEvent(
  action, 'remove', notIn(idsBefore(action), idsAfter(action)),
);

export const basketAddMany = (action) => {
  const added = notIn(idsAfter(action), idsBefore(action));
  if (!added.length) return basketEvent(action, 'add', added);
  return added.map(id => basketEvent(action, 'add', [id]));
};
